
import { initializeApp } from "firebase/app";
import { getFirestore, collection, Firestore } from "firebase/firestore";
import {getStorage } from "firebase/storage";
import {getAuth} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "AIzaSyB8CBlMd8g89O6cP5FEx9DRuNDLA_SfFIk",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "teamsheet1-67d8d.firebaseapp.com",
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL || "https://teamsheet1-67d8d-default-rtdb.firebaseio.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "teamsheet1-67d8d",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "teamsheet1-67d8d.appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "1012626793107",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "1:1012626793107:web:afe1b34c01e3358a8c6366",
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID || "G-HPNH55QL55"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const Admin = initializeApp(firebaseConfig, "Secondary"); // Intialise "fbAdmin" as instance named "Secondary".
const authAdmin = getAuth(Admin); // Get the Auth service for the secondary app
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
export { db, auth, storage , authAdmin };
